module.exports = __webpack_public_path__ + "img/James_Lester.b42f9d7b.jpg";